<template>
    <q-page class="q-pa-md">
        <three_pl_lot_numbers ref="three_pl_lot_numbers"></three_pl_lot_numbers>
    </q-page>
</template>

<script>
    export { default } from './threepllotnumbersapplicationviewmodel-custom-screen.js'
</script>